import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import {
    selectors as googleDataSelectors,
} from '../../appstate';
import { fetchPlaceDetailsAction } from '../fetchPlaceDetails';
import { fetchPlacePredictionsAction } from '../fetchPlacePredictions';
import { serializePredictionParams } from '../utils';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-ducks-google:fetchPlaceFromText');

async function getTopPrediction(dispatch, getState, opts) {
    let topPrediction = googleDataSelectors.selectTopPrediction(getState(), opts);
    if (topPrediction) {
        return topPrediction;
    }

    await dispatch(fetchPlacePredictionsAction.fetch(opts));
    topPrediction = googleDataSelectors.selectTopPrediction(getState(), opts);
    if (!topPrediction) {
        throw new Error(`Google prediction could not be found for ${opts.input}`);
    }

    return topPrediction;
}

function fetch(opts) {
    return async (dispatch, getState) => {
        const id = serializePredictionParams(opts);

        const hasFetched = selectors.selectSuccess(getState(), id);
        const isFetching = selectors.selectWorking(getState(), id);
        if (hasFetched || isFetching) {
            return;
        }

        dispatch(actions.startWork(id));

        let error;
        let meta;
        try {
            const { placeId } = await getTopPrediction(dispatch, getState, opts);
            await dispatch(fetchPlaceDetailsAction.fetch(placeId));
            return placeId;
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(id, meta, error));
        }
    };
}

const fetchPlaceFromTextAction = {
    fetch,
    ...selectors,
};

export {
    fetchPlaceFromTextAction,
};

export default {
    [namespace]: reducer,
};
